import { render, staticRenderFns } from "./viewPolicy.vue?vue&type=template&id=6b99a2b0&scoped=true&"
import script from "./viewPolicy.vue?vue&type=script&lang=js&"
export * from "./viewPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99a2b0",
  null
  
)

export default component.exports